import { render } from "./TDatatable.vue?vue&type=template&id=01e3ad8e"
import script from "./TDatatable.vue?vue&type=script&lang=js"
export * from "./TDatatable.vue?vue&type=script&lang=js"

import "./TDatatable.vue?vue&type=style&index=0&id=01e3ad8e&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__